import { TransactionHistory } from "apiEndPoints";
import APIrequest from "services/axios";
import { logger } from "utils";

export const AdminTransactionService = {
    getTransactionList: async ({queryParams}) => {
        try {
            const payload = {
                ...TransactionHistory.getAllTransaction,
                queryParams,
            };
            return await APIrequest(payload);
        } catch (err) {
            logger(err);
        }
    },
};
